var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (articles, header, hideMore) {
if ( header)
{
buf.push("<div class=\"articles-grid__header\">" + (jade.escape(null == (jade_interp = header) ? "" : jade_interp)) + "</div>");
}
buf.push("<div class=\"articles-grid__articles js-articles-grid-articles grid-3-up\"></div>");
if (!( hideMore))
{
buf.push("<div class=\"js-articles-grid-more articles-grid__more-button\">");
if ( articles.length && !(articles.length >= articles.count))
{
buf.push("<button class=\"avant-garde-button-white is-block js-load-more-articles\">More Articles" + (jade.escape(null == (jade_interp = ' ') ? "" : jade_interp)));
if ( articles.count)
{
buf.push("(" + (jade.escape((jade_interp = articles.count - articles.length) == null ? '' : jade_interp)) + ")");
}
buf.push("</button>");
}
buf.push("</div>");
}}.call(this,"articles" in locals_for_with?locals_for_with.articles:typeof articles!=="undefined"?articles:undefined,"header" in locals_for_with?locals_for_with.header:typeof header!=="undefined"?header:undefined,"hideMore" in locals_for_with?locals_for_with.hideMore:typeof hideMore!=="undefined"?hideMore:undefined));;return buf.join("");
};
module.exports = template;